// CDN herkese açık statik dosya sunar. API için eklenen başlıklar (token, birim, satış kanalı) burada işe yaramaz
// ve tarayıcıya her istekte önce izin sordurur (OPTIONS); environment parametresi de CDN için anlamsızdır.
const CORS_SAFELISTED_HEADERS = ["accept", "accept-language", "content-language"];

export function isCdnRequest(config, cdnUrl) {
  return Boolean(cdnUrl && config.url && config.url.startsWith(cdnUrl));
}

export function toPlainCdnRequest(config) {
  Object.keys(config.headers.toJSON()).forEach((name) => {
    if (!CORS_SAFELISTED_HEADERS.includes(name.toLowerCase())) {
      config.headers.delete(name);
    }
  });
  config.params = undefined;
  return config;
}
